import Vue from "vue";
import VueI18n from "vue-i18n";
import zh from "./lang/zh.js";
import en from "./lang/en.js";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: localStorage.getItem("locale") || "zh", // 当前语言
  messages: {
    zh: {
      ...zh,
    },
    en: {
      ...en,
    },
  },
});

export default i18n;



// WEBPACK FOOTER //
// ./src/locale/index.js